
import cn from 'classnames';
import { numberWithSpaces } from '../../../../utils';
import Button from '../../Buttons/Button';
import styles from './styles.module.scss';


const NavTabs = ({
  open_tab = {},
  getTabName,
  // flexRows,
  getCountStockByMap,
  onChange = () => { },
  tabs = [],
  isNum = false,
  num = [],
  style_tab,
  style_tabs,
  style_selected,
}) => {

  return (
    <div className={cn(styles.tabs, style_tabs)}>
      {tabs.map((tab, index) => (
        <Button
          className={cn(styles.tab, style_tab, (getTabName ? open_tab === tab : open_tab === index) && style_selected)}
          key={tab}
          onClick={() => onChange(getTabName ? tab : index)}
        >
          {tab} {isNum && <div className={styles.num}>{numberWithSpaces(getCountStockByMap ? num[tab] : num[index])}</div>}
          <span className={cn(styles.line, (getTabName ? open_tab === tab : open_tab === index) && styles.active_line)} />
        </Button>
      ))}
    </div>
  )
}


export default NavTabs;
